import type { FC } from "react";

import { useDispatch } from "react-redux";
import styled from "styled-components";

import { EmptyState, IconButton } from "@similarweb/ui-components";

import { showDurationFilterHof } from "app/actions/WebsiteAnalysisFilterActions";
import { allTrackers } from "app/services/track/track";
import { translate } from "app/filters/i18nFilter";
import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const IconButtonStyled = styled(IconButton)`
    width: fit-content;
`;
const StyledEmptyState = styled(EmptyState)`
    padding: 12px;
`;

const CtaButtons: FC = () => {
    const dispatch = useDispatch();

    const openDatePicker = () => {
        allTrackers.dispatchTrackEvent("Button", "click", "Empty state heatmap/open duration filter");
        const showDurationFilter = showDurationFilterHof(dispatch);
        showDurationFilter();
    };

    return (
        <IconButtonStyled
            iconName="daily-ranking"
            iconSize="xs"
            onClick={openDatePicker}
            type="outlined"
        >
            {translate("mmx.heatmaps.empty.state.cta")}
        </IconButtonStyled>
    );
};

export const EmptyStateHeatmap: FC = () => {
    return (
        <FlexColumn
            gap="16px"
            justifyContent="center"
            alignItems="center"
        >
            <StyledEmptyState
                title={translate("mmx.heatmaps.empty.state.title")}
                subtitle={translate("mmx.heatmaps.empty.state.subtitle")}
                CtaButtons={CtaButtons}
            />
        </FlexColumn>
    );
};
